import { api } from "./httpClient";

export const authService = {
  login(credentials) {
    return api("/auth/login", {
      method: "POST",
      body: JSON.stringify(credentials),
    });
  },
};
